@if (isLoading) {
  <div id="spinner">
    <mat-progress-spinner class="mat-spinner-color" mode="indeterminate"></mat-progress-spinner>
  </div>
}
<div class="form-container">
  <div class="header">
    <div class="left">
      <h2>Generate Key</h2>
    </div>
    <div class="right">
      <ol class="breadcrumb">
        <li>
          <span [routerLink]="['/Dashboard']" routerLinkActive="router-link-active">Home</span>
        </li>
        <li>
          <span [routerLink]="['/dev-console']" routerLinkActive="router-link-active">Developer Console</span>
        </li>
        <li>
          <span [routerLink]="['/generate-key']" routerLinkActive="router-link-active" class="disabled">Generate Key</span>
        </li>
      </ol>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="generate-key-form">
    <div class="form-group">
      <label>Monthly Request Limit</label>
      <input formControlName="usageLimit" type="number" min="1" placeholder="Enter the number of requests allowed per month"/>
    </div>

    <div class="form-group">
      <label>Expiration Date</label>
      <input formControlName="expiresAt" type="date" [min]="today" (keydown)="preventTyping($event)">
    </div>
    <button type="submit" class="submit-btn">Create Key</button>
  </form>
</div>
@if (showRoleModal) {
  <div class="modal-backdrop">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Select Role Access</h3>
        <button class="close-key" (click)="cancelRoles()">×</button>
      </div>
      <div class="role-list">
        @if (availableRoles.length === 0) {
          <div class="no-roles">
            No Roles found
          </div>
        }
        @for (role of availableRoles; track role) {
          <div class="role-item">
            <input
              type="checkbox"
              [checked]="selectedRoles.includes(role)"
              (change)="toggleRole(role, $event.target.checked)"
              id="chk-{{role}}"
              />
              <label for="chk-{{role}}">{{ role }}</label>
            </div>
          }
        </div>
        <div class="modal-actions">
          <button (click)="confirmRoles()">Confirm</button>
          <button (click)="cancelRoles()">Close</button>
        </div>
      </div>
    </div>
  }